<template>
  <PopupButton
    :placement="'bottom'"
    :offset="3"
    class="config-warnings"
    :class="highlightOn ? 'config-warnings-hide' : ''"
  >
    <template #button>
      <ConfigWarningsIndicator
        class="animate-pulse hover:animate-none px-2"
        :class="indicatorClass ?? ''"
      />
    </template>

    <template #popup>
      <div class="py-3 px-4 min-w-[640px] max-w-2xl">
        <ul class="list-disc pl-3">
          <li v-for="(warning, id) in kb.warnings" :key="id" class="pb-1">
            {{ warning.short }}

            <p class="text-sm text-justify">{{ warning.long }}</p>

            <ul class="text-sm list-[circle] pl-4">
              <li
                v-for="(loc, locid) in warning.locations"
                :key="locid"
                class="link"
                @click="showLocation(loc)"
              >
                At layer {{ loc.layer }}, row {{ loc.row }}, column
                {{ loc.column }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </template>
  </PopupButton>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Location } from "@/keyboard";
import { useKeyboardStore, useHighlightStore } from "@/stores";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConfigWarningsIndicator from "@/components/config/ConfigWarningsIndicator.vue";

const kb = useKeyboardStore();
const hl = useHighlightStore();

defineProps<{
  indicatorClass?: string;
}>();

const highlightOn = ref(false);

const showLocation = (loc: Location) => {
  kb.setLayer(loc.layer);

  const duration = 1000; // ms
  hl.setHighlightedLayer(loc.layer, duration);
  hl.setHighlightedKey(loc.row, loc.column, duration);

  highlightOn.value = true;
  setTimeout(() => (highlightOn.value = false), duration);
};
</script>

<style>
.config-warnings .menu-popup {
  @apply transition-opacity ease-in-out duration-500;
}

.config-warnings.config-warnings-hide .menu-popup {
  @apply opacity-10;
}
</style>
